/*
Model defined for Maintaining User Responses. It can also be used for transferring model
*/

export class UserResponseModel {
    id: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    mobile: string;
    forceChangePassword: Boolean;
    photo: string;
    roles: any;
    permissions: any;
    emailVerified: Boolean;
    mobileVerified: Boolean;
    admin: Boolean;
    active: Boolean;
    deleted: Boolean;
    roleList: string;
    roleId: string;
    selectedRole: number;
    branch: any;
    branchName: string;
    roleIds: any;
    uiRoles: string[];
    uiPermissions: any = [];
    address: string;
    state: string;
    city: string;
    country: string;
    pinCode: string;
    branchId: string;
    status: string;
    thirdPartyUserId: number;
    rrAgent: boolean;
    department: string;
    cdpRole: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/user/UserResponseModel.ts